var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39271 7.85708H4.60702C4.3713 7.85708 4.21415 8.01421 4.21415 8.24993C4.21415 8.48565 4.3713 8.64278 4.60702 8.64278H5.39272C5.62844 8.64278 5.78558 8.48565 5.78558 8.24993C5.78558 8.01421 5.62844 7.85708 5.39272 7.85708H5.39271ZM8.53557 9.4285H8.1427C8.1427 7.7785 7.19985 6.83564 6.57128 6.1285C6.33556 5.89278 6.02128 5.65708 6.02128 5.49993C6.02128 5.42136 6.25699 5.26421 6.41413 5.18565C7.0427 4.71421 8.1427 3.84993 8.1427 1.57136H8.53556C8.77128 1.57136 8.92841 1.41421 8.92841 1.1785C8.92841 0.942781 8.77128 0.785645 8.53556 0.785645H1.46414C1.22843 0.785645 1.07129 0.942781 1.07129 1.1785C1.07129 1.41421 1.22843 1.57136 1.46414 1.57136H1.857C1.857 3.84993 2.957 4.71421 3.58557 5.18565C3.74271 5.26421 3.97843 5.42136 3.97843 5.49993C3.97843 5.65708 3.66414 5.89278 3.42843 6.20708C2.79986 6.83564 1.85702 7.7785 1.85702 9.4285H1.46415C1.22844 9.4285 1.0713 9.58565 1.0713 9.82136C1.0713 10.0571 1.22844 10.2142 1.46415 10.2142H8.53558C8.7713 10.2142 8.92844 10.0571 8.92844 9.82136C8.92844 9.58565 8.7713 9.4285 8.53558 9.4285H8.53557ZM2.64271 9.4285C2.64271 8.09278 3.42843 7.30708 3.97843 6.6785C4.37129 6.28565 4.76414 5.89278 4.76414 5.49993C4.76414 5.0285 4.44986 4.79278 4.057 4.55708C3.42843 4.08564 2.64271 3.45708 2.64271 1.57136H7.35701C7.35701 3.45708 6.5713 4.08564 5.94272 4.55708C5.54986 4.79277 5.23557 5.0285 5.23557 5.49993C5.23557 5.97136 5.62843 6.28565 6.02129 6.6785C6.57129 7.30708 7.357 8.09278 7.357 9.4285H2.6427H2.64271Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(-0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.006d9a98555a19289419250050c4ae46.svg";
export { ForwardRef as ReactComponent };